module.exports = __webpack_public_path__ + "img/paint-bucket.0dfb3cc9.svg";